import { useEffect, useState } from "react";
import api from "../api";

const dt = (d) => { try { return new Date(d).toLocaleDateString("it-IT", { weekday: "short", day: "numeric", month: "short" }); } catch { return d; } };
const when = (iso) => { try { return new Date(iso).toLocaleString("it-IT", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export default function ConfirmationsPanel() {
  const [data, setData] = useState(null);
  const [done, setDone] = useState({});
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    api.get("/appointments/confirmations").then((r) => setData(r.data)).catch(() => {});
  }, []);
  const sollecita = async (id) => {
    setBusy(id);
    try {
      const r = await api.post(`/appointments/${id}/remind-confirm`);
      setDone((s) => ({ ...s, [id]: r.data.queued ? "In 'Da approvare' ✓" : "Inviato ✓" }));
    } catch (e) { alert(e.response?.data?.detail || e.message); }
    setBusy(null);
  };
  if (!data || (data.confirmed.length === 0 && data.waiting.length === 0)) return null;
  return (
    <div className="panel" data-testid="confirmations-panel">
      <h3 style={{ marginTop: 0 }}>📅 Conferme appuntamenti</h3>
      <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 240 }}>
          <p style={{ margin: "0 0 6px", fontWeight: 700, color: "var(--green)" }}>✅ Hanno confermato (ultime 48h)</p>
          {data.confirmed.length === 0 ? <p className="muted" style={{ fontSize: 13 }}>Nessuna conferma recente.</p> :
            data.confirmed.map((a) => (
              <div key={a.id} style={{ fontSize: 13, padding: "4px 0", borderBottom: "1px solid var(--border)" }} data-testid={`confirmed-${a.id}`}>
                <b>{a.name}</b> — appuntamento {dt(a.date)} ore {a.time}
                <span className="muted"> · confermato {when(a.confirmed_at)}</span>
              </div>
            ))}
        </div>
        <div style={{ flex: 1, minWidth: 240 }}>
          <p style={{ margin: "0 0 6px", fontWeight: 700, color: "#fde047" }}>⏳ In attesa di risposta</p>
          {data.waiting.length === 0 ? <p className="muted" style={{ fontSize: 13 }}>Nessuno in attesa.</p> :
            data.waiting.map((a) => (
              <div key={a.id} style={{ fontSize: 13, padding: "4px 0", borderBottom: "1px solid var(--border)", display: "flex", alignItems: "center", gap: 8 }} data-testid={`waiting-${a.id}`}>
                <span style={{ flex: 1 }}><b>{a.name}</b> — appuntamento {dt(a.date)} ore {a.time}</span>
                {done[a.id]
                  ? <span className="muted" style={{ fontSize: 12 }} data-testid={`sollecito-done-${a.id}`}>{done[a.id]}</span>
                  : <button className="btn sm" onClick={() => sollecita(a.id)} disabled={busy === a.id} data-testid={`sollecito-btn-${a.id}`}>{busy === a.id ? "…" : "📲 Sollecita"}</button>}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
